import { client } from "../../axios/client";
import { required } from "../../utils/validation-campaigns.utils";
import { normalizePaginatedResponse, cleanFilters } from "../../utils/pagination-campaigns.utils";

export const listContactsCatalog = async ({
  idCustomer,
  token,
  offset = 0,
  limit = 20,
  filters = {},
}) => {
  required(idCustomer, 'id_customer');
  required(token, 'access token');

  const sanitizedFilters = cleanFilters(filters);

 const { data } = await client.get(`/contacts/advanced/${idCustomer}`, {
    headers: { Authorization: `Bearer ${token}` },
    params: { offset, limit, ...sanitizedFilters },
  });

  return normalizePaginatedResponse(data, offset, limit);
};

export const searchContactsByNameCatalog = async ({
  firstName,
  idCustomer,
  token,
  offset = 0,
  limit = 20,
}) => {
  required(idCustomer, 'id_customer');
  required(token, 'access token');
  required(firstName, 'first_name');

  const trimmedName = firstName.trim();
  if (!trimmedName) {
    throw new Error('first_name cannot be empty');
  }

  const { data } = await client.post(
    `/contacts/name/${idCustomer}`,
    { first_name: trimmedName, offset, limit },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    }
  );

  return normalizePaginatedResponse(data, offset, limit);
};